import {
  ConnectorName,
  ConnectorNameEnum,
  walletLocalStorageKey,
  connectorLocalStorageKey,
  ExternalName
} from '@mprolab/sdk'
import { connectors } from 'config/walletConnect/config'
import { isDesktop } from 'react-device-detect'

export const walletConnectConfig = connectors.find((connector) => connector.title === ConnectorNameEnum.WALLETCONNECT)

export const saveConnectorToLocalStorage = (connectorId: ConnectorName | ExternalName, title: string) => {
  if (title === ConnectorNameEnum.TRUSTWALLET && walletConnectConfig && isDesktop) {
    localStorage?.setItem(walletLocalStorageKey, title)
    localStorage?.setItem(connectorLocalStorageKey, walletConnectConfig.connectorId)
  } else {
    localStorage?.setItem(walletLocalStorageKey, title)
    localStorage?.setItem(connectorLocalStorageKey, connectorId)
  }
}
